import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { getters } from '@/modules/core/app/helpers/store';

export class BankAccountType extends Enum {
  static CHECKING = {
    key: 'depository_checking',
    get value() {
      return getters.auth.getCurrentEstate()?.jurisdiction.isInCanada
        ? Lang.t('asset.chequing')
        : Lang.t('asset.checking');
    }
  };

  static SAVINGS = {
    key: 'depository_savings',
    get value() {
      return Lang.t('asset.savings');
    }
  };

  static HSA = {
    key: 'depository_hsa',
    get value() {
      return Lang.t('asset.hsa');
    }
  };

  static CD = {
    key: 'depository_cd',
    get value() {
      return Lang.t('asset.cd');
    }
  };

  static MONEY_MARKET = {
    key: 'depository_money_market',
    get value() {
      return Lang.t('asset.money-market');
    }
  };

  static PAYPAL = {
    key: 'depository_paypal',
    get value() {
      return Lang.t('asset.paypal');
    }
  };

  static INVESTMENT_529 = {
    key: 'investment_529',
    value: '529'
  };

  static INVESTMENT_403B = {
    key: 'investment_403b',
    value: '403B'
  };

  static INVESTMENT_401K = {
    key: 'investment_401k',
    value: '401K'
  };

  static INVESTMENT_457B = {
    key: 'investment_457b',
    value: '457B'
  };

  static INVESTMENT_BROKERAGE = {
    key: 'investment_brokerage',
    value: 'BROKERAGE'
  };

  static INVESTMENT_401A = {
    key: 'investment_401a',
    value: '401A'
  };

  static INVESTMENT_CASH_ISA = {
    key: 'investment_cash_isa',
    value: 'CASH ISA'
  };

  static INVESTMENT_EDUCATION_SAVINGS_ACCOUNT = {
    key: 'investment_education_savings_account',
    value: 'EDUCATION SAVINGS ACCOUNT'
  };

  static INVESTMENT_FIXED_ANNUITY = {
    key: 'investment_fixed_annuity',
    value: 'FIXED_ANNUITY'
  };

  static INVESTMENT_GIC = {
    key: 'investment_gic',
    value: 'GIC'
  };

  static INVESTMENT_HEALTH_REIMBURSEMENT_ARRANGEMENT = {
    key: 'investment_health_reimbursement_arrangement',
    value: 'HEALTH REIMBURSEMENT ARRANGEMENT'
  };

  static INVESTMENT_HSA = {
    key: 'investment_hsa',
    value: 'HSA'
  };

  static INVESTMENT_IRA = {
    key: 'investment_ira',
    value: 'IRA'
  };

  static INVESTMENT_ISA = {
    key: 'investment_isa',
    value: 'ISA'
  };

  static INVESTMENT_KEOGH = {
    key: 'investment_keogh',
    value: 'KEOGH'
  };

  static INVESTMENT_LIF = {
    key: 'investment_lif',
    value: 'LIF'
  };

  static INVESTMENT_LIRA = {
    key: 'investment_lira',
    value: 'LIRA'
  };

  static INVESTMENT_LRIF = {
    key: 'investment_lrif',
    value: 'LRIF'
  };

  static INVESTMENT_LRSP = {
    key: 'investment_lrsp',
    value: 'LRSP'
  };

  static INVESTMENT_MUTUAL_FUND = {
    key: 'investment_mutual_fund',
    value: 'MUTUAL FUND'
  };

  static INVESTMENT_PENSION = {
    key: 'investment_pension',
    value: 'PENSION'
  };

  static INVESTMENT_PRIF = {
    key: 'investment_prif',
    value: 'PRIF'
  };

  static INVESTMENT_PROFIT_SHARING_PLAN = {
    key: 'investment_profit_sharing_plan',
    value: 'PROFIT SHARING PLAN'
  };

  static INVESTMENT_NON_TAXABLE_BROKERAGE_ACCOUNT = {
    key: 'investment_non_taxable_brokerage_account',
    value: 'NON TAXABLE BROKERAGE ACCOUNT'
  };

  static INVESTMENT_QSHR = {
    key: 'investment_qshr',
    value: 'QSHR'
  };

  static INVESTMENT_RDSP = {
    key: 'investment_rdsp',
    value: 'RDSP'
  };

  static INVESTMENT_RESP = {
    key: 'investment_resp',
    value: 'RESP'
  };

  static INVESTMENT_RETIREMENT = {
    key: 'investment_retirement',
    value: 'RETIREMENT'
  };

  static INVESTMENT_RLIF = {
    key: 'investment_rlif',
    value: 'RLIF'
  };

  static INVESTMENT_ROTH = {
    key: 'investment_roth',
    value: 'ROTH'
  };

  static INVESTMENT_ROTH_401K = {
    key: 'investment_roth_401k',
    value: 'ROTH 401K'
  };

  static INVESTMENT_RRIF = {
    key: 'investment_rrif',
    value: 'RRIF'
  };

  static INVESTMENT_RRSP = {
    key: 'investment_rrsp',
    value: 'RRSP'
  };

  static INVESTMENT_SARSEP = {
    key: 'investment_sarsep',
    value: 'SARSEP'
  };

  static INVESTMENT_SEP_IRA = {
    key: 'investment_sep_ira',
    value: 'SEP IRA'
  };

  static INVESTMENT_SIMPLE_IRA = {
    key: 'investment_simple_ira',
    value: 'SIMPLE IRA'
  };

  static INVESTMENT_SIPP = {
    key: 'investment_sipp',
    value: 'SIPP'
  };

  static INVESTMENT_STOCK_PLAN = {
    key: 'investment_stock_plan',
    value: 'STOCK PLAN'
  };

  static INVESTMENT_TFSA = {
    key: 'investment_tfsa',
    value: 'TFSA'
  };

  static INVESTMENT_TRUST = {
    key: 'investment_trust',
    value: 'TRUST'
  };

  static INVESTMENT_UGMA = {
    key: 'investment_ugma',
    value: 'UGMA'
  };

  static INVESTMENT_VARIABLE = {
    key: 'investment_variable',
    value: 'VARIABLE'
  };

  static INVESTMENT_UTMA = {
    key: 'investment_utma',
    value: 'UTMA'
  };

  static INVESTMENT_VARIABLE_ANNUITY = {
    key: 'investment_variable_annuity',
    value: 'VARIABLE ANNUITY'
  };
}
